export default __webpack_public_path__ + "dacd24a27f87b6ecb9b0c25188f78819.svg";